import styled from 'styled-components';

interface InputProps {
    type?: string;
}

export const Container = styled.label<InputProps>`
    display: block;
    min-height: 88px;
    position: relative;    
    .title {
        display: block;
        font-size: 14px;
        font-weight: 500;
        width: 100%;
        color: ${({ theme }) => theme.colors.interfaceText400};
        
        span {
            color: ${({ theme }) => theme.colors.primaryRed400};
            margin-left: 4px;
        }
    }
    input {
        width: 100%;
        height: 48px;
        background: ${({ theme }) => theme.colors.interfacePure0};
        border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
        outline: none;
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfaceText500};
        padding: 12px 16px;
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        transition: all 0.2s ease;
        
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.interfaceGray400};
        }

        /* Autofill do navegador: mantém o fundo/cor do tema (sem o azulado/amarelado do Chrome) */
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.colors.interfacePure0} inset !important;
            -webkit-text-fill-color: ${({ theme }) => theme.colors.interfaceText500} !important;
            caret-color: ${({ theme }) => theme.colors.interfaceText500};
            transition: background-color 9999s ease-in-out 0s;
        }

        &:disabled {
            background: ${({ theme }) => theme.colors.interfacePure100};
            color: ${({ theme }) => theme.colors.interfaceGray900};
            border-color: ${({ theme }) => theme.colors.interfaceText200};
            cursor: not-allowed;
        }
    }
    &.empty {
        input {
            border: 1px solid ${({ theme }) => theme.colors.interfaceDanger};
        }
    }
    &.error {
        input {
            border: 1px solid ${({ theme }) => theme.colors.primaryRed400};
        }
    }
    span {
        display: inline;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.interfaceDanger};
        margin-top: 4px;
        min-height: 16px;
    }
`;